import type { CommandeFacturable, CreationFacturePayload } from "@/types/domain";

export function creerCleFacturation(action: string, reference: string): string {
  const uuid = globalThis.crypto?.randomUUID?.();
  const aleatoire = uuid || `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `PHASE6-${action}-${reference}-${aleatoire}`.slice(0, 200);
}

export function construireCreationFacture(
  commande: CommandeFacturable,
  quantites: Record<string, number>,
  idempotencyKey: string,
): CreationFacturePayload {
  if (commande.lignes.some((ligne) => ligne.expedition_id !== commande.expedition_id)) {
    throw new Error("Le regroupement de plusieurs expéditions est interdit.");
  }
  const lignes = commande.lignes.flatMap((ligne) => {
    const quantite = quantites[ligne.ligne_expedition_id] ?? 0;
    if (!Number.isInteger(quantite) || quantite < 0) {
      throw new Error(`Quantité invalide pour ${ligne.sku}.`);
    }
    if (quantite !== ligne.quantite_restante) {
      throw new Error(`La facture doit reprendre toute la quantité expédiée de ${ligne.sku}.`);
    }
    if (!Number.isFinite(ligne.prix_unitaire_po) || ligne.prix_unitaire_po < 0) {
      throw new Error(`Prix PO validé absent pour ${ligne.sku}.`);
    }
    return quantite > 0
      ? [{ ligne_expedition_id: ligne.ligne_expedition_id, quantite }]
      : [];
  });
  if (lignes.length === 0) {
    throw new Error("Sélectionnez au moins une quantité réellement expédiée.");
  }
  return { idempotency_key: idempotencyKey, lignes };
}

export function calculerSousTotalApercu(
  commande: CommandeFacturable,
  quantites: Record<string, number>,
): number {
  return commande.lignes.reduce(
    (total, ligne) =>
      total + (quantites[ligne.ligne_expedition_id] || 0) * ligne.prix_unitaire_po,
    0,
  );
}
